export default __webpack_public_path__ + "static/media/finance-topic2.9268cf11.png";